import type { CommonProps } from '../../types';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { Text } from '../../';
import { NEXT_LOCALES } from '@beat-venues/common-types';

export interface LanguageSwitcherProps
    extends CommonProps,
        VariantProps<typeof LanguageSwitcherStyles> {
    currentLanguage: string;
    supportedLanguages: typeof NEXT_LOCALES;
    changeLanguage: (language: string) => void;
}

export const LanguageSwitcherStyles = cva('flex justify-end gap-3');

export const LanguageSwitcher = ({
    className,
    currentLanguage,
    supportedLanguages = NEXT_LOCALES,
    changeLanguage,
    testId = 'language-switcher',
}: LanguageSwitcherProps): JSX.Element => {
    const languages: Record<string, string> = {
        nl: 'Nederlands',
        fr: 'Français',
        en: 'English',
    };

    return (
        <div
            className={twMerge(LanguageSwitcherStyles({ className }))}
            data-testid={testId}
        >
            {supportedLanguages.map((language) => {
                return (
                    <button
                        key={`btn-language-${language}`}
                        type="button"
                        onClick={() => changeLanguage(language)}
                    >
                        <Text
                            className={`${
                                currentLanguage === language
                                    ? 'font-bold'
                                    : 'font-light'
                            }`}
                            size="xl"
                        >
                            <span className="sr-only">
                                {languages[language]}
                            </span>
                            <span aria-hidden="true">
                                {language.toUpperCase()}
                            </span>
                        </Text>
                    </button>
                );
            })}
        </div>
    );
};
